type AvatarStackProps = {
  initials: string[];
  overflow?: number;
};

/** A small overlapping stack of illustrative initial avatars, with an optional "+N". */
export function AvatarStack({ initials, overflow }: AvatarStackProps) {
  return (
    <div className="flex">
      {initials.map((label, index) => (
        <div key={label} className="rounded-full border-2 border-white" style={{ marginLeft: index === 0 ? 0 : -8 }}>
          <div className="relative inline-flex size-8 shrink-0">
            <div
              className="flex h-full w-full items-center justify-center overflow-hidden rounded-full"
              style={{ background: "var(--color-bg-tertiary)", border: "0.75px solid var(--color-border-secondary)" }}
            >
              <span className="text-sm font-semibold leading-none" style={{ color: "var(--color-text-quaternary)" }}>
                {label}
              </span>
            </div>
          </div>
        </div>
      ))}
      {overflow != null && (
        <div className="rounded-full border-2 border-white" style={{ marginLeft: -8 }}>
          <div className="inline-flex size-8 items-center justify-center rounded-full bg-gray-100 text-[11px] font-semibold text-gray-700">
            +{overflow}
          </div>
        </div>
      )}
    </div>
  );
}
